import { render, staticRenderFns } from "./FarmImage.vue?vue&type=template&id=2a0b86c1&"
import script from "./FarmImage.vue?vue&type=script&lang=js&"
export * from "./FarmImage.vue?vue&type=script&lang=js&"
import style0 from "./FarmImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports